import { TeaBlocksError } from './../../TeaBlocksError';
import { ReturnBlock } from "../ReturnBlock";

/**
 * Block for retrieving the value of a variable from the variable
 * environment based on the variable name.
 */
export class VarRetrieveBlock extends ReturnBlock {
    varName: string;

    /**
     * Constructor.
     * @param varName variable name
     */
    constructor(id: string, varName: string) {
        super(id)
        this.varName = varName;
    }

    /**
     * Retrives the value under varName from variable environment if that variable exists.
     * @param varEnv the variable envornment
     */
    evalBlock(varEnv: Map<string, any>): void {
        if (this.varName.includes('$') || this.varName.includes('&')) {
            throw new TeaBlocksError('Variable name contains illegal character', this.id);
        }
        
        if (!varEnv.has(this.varName)) {
            throw new TeaBlocksError("Variable " + this.varName + " does not exist", this.id);
        }
        return varEnv.get(this.varName);
    }
}